import 'react';
import { noop } from '../../utils/noop.esm.js';
import '@popperjs/core';

const selectedItemLabel = (selectedItem) => {
    return Array.isArray(selectedItem)
        ? selectedItem.map((item) => item.children || item.value).join(', ')
        : (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.children) || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) || '';
};
const isDomElement = (type) => {
    return /button|div|span/.test(type !== null && type !== void 0 ? type : '');
};
const onSelectedItemChange = ({ changes, enableMultiSelect, selectedItems, selectedValues, onChange = noop, selectAllItem, allSelected, itemsForSelectAll }) => {
    const { selectedItem, type } = changes;
    /* istanbul ignore if */
    if (!selectedItem) {
        return;
    }
    if (enableMultiSelect) {
        const index = selectedValues.indexOf(selectedItem.value);
        const itemAlreadySelected = index >= 0;
        if (selectedItem === selectAllItem) {
            const selectAllValues = itemsForSelectAll.map((item) => item.value);
            onChange === null || onChange === void 0 ? void 0 : onChange({
                type,
                selectedItem: selectAllItem,
                selectedItems: !allSelected
                    ? [
                        ...selectedItems,
                        ...itemsForSelectAll.filter((item) => !item.disabled && !selectedValues.includes(item.value))
                    ]
                    : selectedItems.filter((item) => !selectAllValues.includes(item.value))
            });
        }
        else if (itemAlreadySelected) {
            onChange({
                ...changes,
                selectedItem: selectedItem,
                selectedItems: [...selectedItems.slice(0, index), ...selectedItems.slice(index + 1)].filter(Boolean)
            });
        }
        else {
            onChange({
                ...changes,
                selectedItem: selectedItem,
                selectedItems: [...selectedItems, selectedItem]
            });
        }
    }
    else {
        onChange({
            ...changes,
            selectedItem: selectedItem,
            selectedItems: [selectedItem]
        });
    }
};
const sortBySelected = (selectedValues) => (itemA, itemB) => {
    const itemASelected = selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(itemA.value);
    const itemBSelected = selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(itemB.value);
    return itemASelected === itemBSelected ? 0 : itemASelected ? -1 : 1;
};

export { isDomElement, onSelectedItemChange, selectedItemLabel, sortBySelected };
//# sourceMappingURL=utils.esm.js.map
